export default __webpack_public_path__ + "static/media/chatbot.b4957599.svg";